import WidgetAjax from './../widget/WidgetAjax';

export default class Config 
{
    static getBasePath()
    {
        // const basePath = "http://218.26.73.119:18080/SCRMAPI";
        const basePath = "http://ztfx.elecredit.com/SCRMAPI";
       
        return basePath;
    }

    static getDBID()
    {
        const DBID = 1;
        return DBID;
    }

    static getOBJECTTYPE()
    {
        const objectType = 1;
        return objectType;
    }

    static getMapName()
    {
        return "110105";
    }    

    static getEncryptyType()
    {
        return "MD5";
    }

    static isShowHeaderArea()
    {
        return false;
    }

    static getHermesPanoramaUID()
    {
        return "yx";
    }

    static getHermesPanoramaURL()
    {
        // return "http://218.26.73.119:15868/saic/enterprise/saas";

        // return "http://218.26.73.119:15868/EntityPanorama/panoramaBulletin";

        return "http://218.26.73.116:18080/EntityPanorama/panoramaBulletin";

        // return "http://localhost:8080/EntityPanorama_park/panoramaBulletin";
    }

    static getHermesAccess( callback )
    {
        // WidgetAjax.ajax({
        //     url : "http://218.26.73.119:15868/EntityPanorama/createToken",
        //     params : null, 
        //     'callback' : callback
        // });

//         WidgetAjax.ajax({
//             url : "http://218.26.73.119:15868/saic/enterprise/saas",
//             params : null, 
//             'callback' : callback
//         });

        WidgetAjax.ajax({
            url : "http://218.26.73.116:18080/EntityPanorama/createToken",
            params :null,
            'callback' : callback
        });

//         WidgetAjax.ajax({
//             url : "http://localhost:8080/EntityPanorama_park/createToken",
//             params : null, 
//             'callback' : callback
//         });
//     
    }

    static getSystemTitle()
    {
        return "银行对公营销获客系统";
    }
}